import type { Vero1ChecklistItem } from "shared/interfaces/api/vero1";
import { Vero1RowKind } from "shared/interfaces/api/vero1";

/** Gate verdicts read the server's flags; only isLeasingTouched and hasResultMoved are computed here. */

export const isLeasingTouched = (
  item: Pick<
    Vero1ChecklistItem,
    "overrideSeverity" | "overrideExplanation" | "reasonCode" | "actionForLeasing"
  >
) =>
  item.overrideSeverity != null ||
  Boolean(item.overrideExplanation) ||
  Boolean(item.reasonCode) ||
  Boolean(item.actionForLeasing);

/** Any contribution at all, internal note included — the server's is_edited. */
export const isAgentTouched = (item: Pick<Vero1ChecklistItem, "isEdited">) =>
  Boolean(item.isEdited);

export const hasResultMoved = (
  item: Pick<Vero1ChecklistItem, "originalSeverity" | "overrideSeverity">
) =>
  item.overrideSeverity != null &&
  item.overrideSeverity !== item.originalSeverity;

/** The findings submit will demand, not yet supplied — the server's flag,
 *  which also knows that whitespace-only text is not findings. */
export const needsFindings = (item: Vero1ChecklistItem) =>
  Boolean(item.needsFindings);

/** The reason submit will demand, not yet supplied — the server's flag. */
export const needsReason = (item: Vero1ChecklistItem) =>
  Boolean(item.needsReason);

/** The client's name submit will demand, not yet picked — the server's flag. */
export const needsName = (item: Vero1ChecklistItem) => Boolean(item.needsName);

/** Spec §09: Continue is the single gate — a missing reason, findings or
 *  client name holds it. */
export const isIncomplete = (item: Vero1ChecklistItem) =>
  needsFindings(item) || needsReason(item) || needsName(item);

export const isAssessable = (item: Vero1ChecklistItem) =>
  item.rowKind !== Vero1RowKind.Fact;

export const isAssessed = (item: Vero1ChecklistItem) =>
  item.overrideSeverity != null ||
  item.originalSeverity != null ||
  isLeasingTouched(item);
